import React, { useState, useEffect } from "react";
import { Table, Tag, Input, Space, Button, Spin } from "antd";
import _ from "lodash"; // Import lodash

import { SearchOutlined } from "@ant-design/icons";
import EditUser from "../components/EditUser";
import axios from "axios";
import { BASE_URL } from "../constants/Constants";

const Tables = () => {
  const userId = localStorage.getItem("userId");
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const res = await axios.get(`${BASE_URL}/users/getAllUsers`);
      // TASK 1 FIX: Reverse the data so new users are at the top (SR NO 1)
      setData(res.data.reverse()); 
      setIsLoading(false);
    };
    const delayedFetchData = _.debounce(fetchData, 0);

    delayedFetchData();

    return () => {
      delayedFetchData.cancel();
    };
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, columnTitle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div className="p-4">
        <Input
          placeholder={`Search ${columnTitle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          className="mb-2"
        />
        <Space>
          <button
            onClick={() => handleReset(clearFilters)}
            className="bg-gray-200 text-gray-800 mr-2 rounded px-4 py-2"
          >
            Reset
          </button>
          <button
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            className="rounded bg-primary px-4 py-2 text-black"
          >
            OK
          </button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const recordValue = record[dataIndex];
      return recordValue
        ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <strong>{text}</strong>
      ) : (
        <span>{text}</span>
      ),
  });

  const columns = [
    {
      title: "SR NO",
      dataIndex: "sr",
      defaultSortOrder: "ascend", 
      className: "bg-boxdark  p-2.5 text-black text-sm font-medium uppercase",
    },
    {
      title: "USER ID",
      dataIndex: "userId",
      ...getColumnSearchProps("userId", "userId"),
      className: "bg-boxdark  p-2.5 text-black text-sm font-medium uppercase",
    },
    {
      title: "NAME",
      dataIndex: "parName",
      ...getColumnSearchProps("parName", "parName"),
      className: "bg-boxdark   text-black hover:bg-unset text-center p-2.5",
    },
    {
      title: "ROLES",
      dataIndex: "acType",
      ...getColumnSearchProps("acType", "acType"),
      className: "bg-boxdark  text-black  p-2.5 text-center",
    },
    // REMOVED: STATUS Column
    {
      title: "PHONE NUMBER",
      dataIndex: "mobile1",
      className: "bg-boxdark  text-black  p-2.5 text-center",
    },
    {
      title: "DETAILS",
      dataIndex: "viewMore",
      render: (_, record) => <EditUser data={record} />,
      className: " text-w hite bg-boxdark p-2.5 text-center",
    },
    // REMOVED: DEACTIVATE USER Column
  ];

  const dataWithSrNo = data.map((item, index) => ({
    ...item,
    key: (index + 1).toString(),
    sr: index + 1,
  }));

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  return userId ? (
    <div className="rounded-sm border border-stroke px-5 pt-6 pb-2.5 text-black shadow-default dark:border-strokedark dark:bg-boxdark dark:text-black sm:px-7.5 xl:pb-1">
      {isLoading ? (
        <Spin />
      ) : (
        <Table
          key={dataWithSrNo.length}
          className="text-black dark:text-black"
          columns={columns}
          dataSource={dataWithSrNo}
          onChange={onChange}
          scroll={{ x: true }}
        />
      )}
    </div>
  ) : (
    <span
      style={{
        fontSize: "20px",
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      Sign in to see users
    </span>
  );
};

export default Tables;